function initTilt() {

	const tilt = document.querySelectorAll('.no-touchevents .tilt');
	VanillaTilt.init(tilt,{
		max: 7,
		glare: true,
		"max-glare": 0.5,
	});

	const tiltLight = document.querySelectorAll('.no-touchevents .tilt-light');
	VanillaTilt.init(tiltLight, {
		max: 3,
		speed: 600,
		scale: 1.03,
		glare: true,
		"max-glare": 0.2,
	});

	const glare = document.querySelectorAll('.no-touchevents .glare');
	VanillaTilt.init(glare, {
		max: 0,
		glare: true,
		"max-glare": 0.5,
	});

	const glareLight = document.querySelectorAll('.no-touchevents .glare-light');
	VanillaTilt.init(glareLight, {
		max: 0,
		glare: true,
		"max-glare": 0.2,
	});
}
